var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-footer", attrs: { id: "tls-footer" } }, [
    _vm.issuer
      ? _c(
          "div",
          { staticClass: "tls-footer-links" },
          _vm._l(_vm._.get(_vm.footerLinkCmsData, "linksItems"), function(
            item
          ) {
            return _c("div", { staticClass: "tls-footer-links--slot" }, [
              _c("div", { staticClass: "tls-footer-links--title" }, [
                _c(
                  "div",
                  { staticClass: "tls-simple-text -color-white -weight-bold" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm._.get(item, "title")) +
                        "\n                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tls-footer-links--list" }, [
                _c(
                  "ul",
                  { staticClass: "tls-link-list" },
                  _vm._l(_vm._.get(item, "links"), function(link) {
                    return _c("li", { staticClass: "tls-link-list--slot" }, [
                      _vm._.get(link, "link_url") === _vm.osano
                        ? _c(
                            "span",
                            {
                              staticClass: "tls-link",
                              on: { click: _vm.onOpenOsano }
                            },
                            [_vm._v(_vm._s(_vm._.get(link, "link_name")))]
                          )
                        : _c(
                            "a",
                            {
                              staticClass: "tls-link",
                              attrs: { href: _vm._.get(link, "link_url") }
                            },
                            [_vm._v(_vm._s(_vm._.get(link, "link_name")))]
                          )
                    ])
                  }),
                  0
                )
              ])
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.issuer ? _c("div", { staticClass: "tls-footer-line" }) : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "tls-footer-content" }, [
      _c("div", { staticClass: "tls-footer--slot" }, [
        _c("a", { staticClass: "tls-logo" }, [
          _c("img", {
            staticClass: "tls-logo--imgs",
            attrs: { src: _vm.logoStyle, alt: "copyright" }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tls-footer--slot tls-sm-visible" }, [
        _c("div", {
          directives: [
            {
              name: "dompurify-html",
              rawName: "v-dompurify-html",
              value: _vm._.get(_vm.footerCmsData, "copyrights"),
              expression: "_.get(footerCmsData, 'copyrights')"
            }
          ],
          staticClass: "tls-simple-text -color-white -size-12"
        }),
        _vm._v(" "),
        _vm.countryCopyrights
          ? _c("div", { staticClass: "tls-footer-beian" }, [
              _vm.isChineseCenter
                ? _c("img", {
                    attrs: {
                      src: _vm.MINIO_BUCKET_ADDRESS + "/badges_icon.png",
                      alt: ""
                    }
                  })
                : _vm._e(),
              _vm._v(" \n                "),
              _c("div", {
                directives: [
                  {
                    name: "dompurify-html",
                    rawName: "v-dompurify-html",
                    value: _vm.countryCopyrights,
                    expression: "countryCopyrights"
                  }
                ],
                ref: "footerBeian"
              })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tls-footer--slot" }, [
        _vm._.indexOf(
          ["ApplierResidenceCountry", "ApplierApplicationCenter"],
          _vm.$route.name
        ) !== -1
          ? _c(
              "div",
              { staticClass: "tls-social-logo-group" },
              _vm._l(_vm._.get(_vm.footerCmsData, "socialMedia"), function(
                socialMedia
              ) {
                return _vm._.get(socialMedia, "logo")
                  ? _c("div", { staticClass: "tls-social-logo-group--slot" }, [
                      _c(
                        "a",
                        {
                          staticClass: "tls-social-logo",
                          attrs: {
                            href: _vm._.get(socialMedia, "link"),
                            target: "_blank",
                            rel: "noopener"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fab tls-social-logo--icon",
                            class: _vm._.get(socialMedia, "logo")
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              }),
              0
            )
          : _c(
              "div",
              { staticClass: "tls-social-logo-group" },
              _vm._l(_vm._.get(_vm.footerLinkCmsData, "socialMedia"), function(
                socialMedia
              ) {
                return _vm._.get(socialMedia, "logo")
                  ? _c("div", { staticClass: "tls-social-logo-group--slot" }, [
                      _c(
                        "a",
                        {
                          staticClass: "tls-social-logo",
                          attrs: {
                            href: _vm._.get(socialMedia, "link"),
                            target: "_blank",
                            rel: "noopener"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fab tls-social-logo--icon",
                            class: _vm._.get(socialMedia, "logo")
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              }),
              0
            )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tls-footer--slot" }, [
        _c("a", { staticClass: "tls-logo" }, [
          _c("img", {
            staticClass: "tls-logo--img",
            attrs: { src: _vm.MINIO_BUCKET_ADDRESS + "/w3c.png", alt: "w3c" }
          })
        ])
      ]),
      _vm._v(" "),
      _vm._.get(_vm.footerLinkCmsData, "ndpr_logo")
        ? _c("div", { staticClass: "tls-footer--slot" }, [
            _c("a", { staticClass: "tls-logo" }, [
              _c("img", {
                staticClass: "tls-logo--img",
                attrs: {
                  src: _vm.MINIO_BUCKET_ADDRESS + "/ndpr_origin.png",
                  alt: "ndpr"
                }
              })
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }